// extracted by mini-css-extract-plugin
export default {"TopNav":"TopNav_TopNav__+40Sb","Logo":"TopNav_Logo__bYZ4t","WorkspaceDropdownWrapper":"TopNav_WorkspaceDropdownWrapper__YemEH"};